import React, { useMemo, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchShareType } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const ShareTypeDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
}) => {
  const shareTypeName = rowData?.share_type_obj
    ? rowData.share_type_obj.share_type
    : rowData?.share_type
    ? rowData.share_type
    : getValues().share_type;

  const selectedShareTypeId = watch("share_type_id");


  const {
    data: shareTypes,
    isLoading,
    error,
  } = useQuery(["Share Types"], () => fetchShareType(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });


  const modifiedData = useMemo(() => {
    return (
      shareTypes?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.share_type,
      })) || []
    );
  }, [shareTypes]);

  const options = useMemo(() => modifiedData, [modifiedData]);

  const selectedOption = useMemo(() => {
    return (
      options.find((option) => option.value === selectedShareTypeId) ||
      options.find((option) => option.label === shareTypeName) ||
      null
    );
  });

  useEffect(() => {
    if (rowData && options.length) {
      const rowDataOption = options.find(
        (option) => option.value === rowData?.share_type_obj?.id
      );
      setValue("share_type_id", rowDataOption?.value);
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Share Types</div>;

  return (
    <Controller
      name="share_type_id"
      control={control}
      rules={{ required: "Share Type is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Share Type"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("share_type_id", value);
          }}
          className={`react-select-container ${
            errors.share_type_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default ShareTypeDropdown;
